import axios from 'axios';

export default {
    async getTotalAdditionalExpensesForCourier(courierInfoId, params) {
        return axios.get(
            `api/courier/${courierInfoId}/total-additional-expenses?${params}`
        );
    },
    async getAdditionalExpenses(orderid) {
        return axios.get(`api/additional-expenses/${orderid}`);
    },
    async getTotalAdditionalExpenses(params) {
        return axios.get(`api/additional-expense-total?${params}`);
    },
    async insertAdditionalExpense(params) {
        return axios.post(`api/additional-expense`, params);
    },

    async updateAdditionalExpense(params) {
        return axios.post(`api/additional-expense/${params.id}`, params);
    },

    async deleteAdditionalExpense(params) {
        return axios.delete(`api/additional-expense/${params.id}`);
    }
};
